import api from "@/api"
import { getAccessToken } from "@/api"
import store from "./store";
import { gerenciadorImagesBaseUrl } from "@/config/gerenciadorConfig";

// URL base das imagens de produtos. Resolvida de forma centralizada em
// @/config/gerenciadorConfig.js (prioriza o runtime-config.js, gerado pela
// tela Configurações > Caminhos e URLs do Gerenciador de Produtos).
const baseImageUrl = gerenciadorImagesBaseUrl()


export default {
    baseImageUrl,
    gerarHash() {
        const caracteres = 'abcdefghijklmnopqrstuvwxyz0123456789';
        let hash = '';
        const comprimentoDesejado = 6;

        for (let i = 0; i < comprimentoDesejado; i++) {
            // Gera um índice aleatório dentro do comprimento da string 'caracteres'
            const indiceAleatorio = Math.floor(Math.random() * caracteres.length);

            // Adiciona o caractere aleatório ao hash
            hash += caracteres.charAt(indiceAleatorio);
        }

        return hash;
    },
    scrollTop() {
        setTimeout(() => {

            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }, 1000);
    },
    isAdmin() {
        return localStorage.getItem('isAdmin') ? true : false
    },

    formatMoney(value) {
        return new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(Number(value) || 0);
    },

    abreviateText(text = '', limite = 100) {
        if (text.length <= limite) {
            return text
        }
        return text.substring(0, limite) + '...'
    },
    getImage(file) {
        if (!file) return '/assets/loading2.gif'
        if (file.includes('http')) return file
        return baseImageUrl + file
    },
    getObjectRaw(obj) {
        let objStr = JSON.stringify(obj)
        return JSON.parse(objStr)
    },
    loadAllImages(cb = () => { }) {
        console.log('carregando imagens');


        api.get('imagens-produto')
            .then(res => {
                store.state.imagensDeProduto = res
                cb()
            })
    },
    async getImageV2(file) {
        let url = baseImageUrl + file
        // Se o arquivo não existir ou for nulo, retorna a imagem padrão
        if (!file) {
            return '/assets/loading2.gif';
        }

        // Se o caminho já for uma URL completa, retorna-o diretamente
        if (file.includes('http')) {
            return file;
        }

        // Constrói a URL completa para a imagem
        const imageUrl = baseImageUrl + file;

        try {
            // Faz uma requisição HEAD para verificar se a imagem existe
            const response = await fetch(imageUrl, { method: 'HEAD' });

            // Se a resposta for bem-sucedida (status 200-299), a imagem existe
            if (response.ok) {
                return url;
            } else {
                // Se a resposta não for ok (ex: 404), a imagem não existe
                return '/assets/loading2.gif';
            }
        } catch (error) {
            // Em caso de erro de rede ou outro problema, assume que a imagem não existe
            console.error(`Erro ao verificar a imagem ${imageUrl}:`, error);
            return '/assets/loading2.gif';
        }
    },
    redirectTo(url, refresh = false) {
        window.location.href = url
        if (refresh) {
            window.location.reload()
        }
    },
    // Converte uma string para Base64 (suporta Unicode)
    encodeBase64(str) {
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1) =>
            String.fromCharCode('0x' + p1)
        ));
    },

    // Converte uma string Base64 de volta para string original
    decodeBase64(base64) {
        return decodeURIComponent(
            Array.prototype.map.call(atob(base64), c =>
                '%' + c.charCodeAt(0).toString(16).padStart(2, '0')
            ).join('')
        );
    },

    buscarEndereco(cep, onSuccess, onError) {
        fetch(`https://viacep.com.br/ws/${cep}/json/`)
            .then(async (response) => {
                onSuccess(await response.json())
            })
            .catch(onError)
    },

    getEmailCliente() {
        let cliente = localStorage.getItem('addon')
        if (!cliente) return null

        cliente = JSON.parse(cliente)

        return cliente.usuario.email
    },
    // Retorna os dados completos do cliente autenticado (nome, cnpj,
    // endereço salvo etc.), já cacheados em localStorage desde o login
    // (ver getAddon() em api.js) - evita uma nova chamada de rede só para
    // pré-preencher campos como Razão Social/CNPJ no checkout.
    getClienteData() {
        let addon = localStorage.getItem('addon')
        if (!addon) return null

        try {
            addon = JSON.parse(addon)
        } catch (e) {
            return null
        }

        return addon?.cliente || null
    },
    clienteLogado() {
        let addon = localStorage.getItem('addon')
        if (!addon) {
            return false
        } else {
            addon = JSON.parse(addon)
        }
        if (addon?.cliente?.id) {
            return true
        }

        return false
    },

    getImageBackend(filename) {
        if (!filename) return null

        if (filename.includes('data:')) return filename

        if (filename.includes('http')) return filename

        // Fallback para quando a imagem vem como um nome de arquivo "solto"
        // (sem URL completa) - as imagens do Gerenciador ficam na pasta
        // /images dele, e não mais em /api/static/ (endpoint antigo do
        // Railway, que não existe mais).
        return api.host + '/images/' + filename
    },

    getIDCliente() {
        let cliente = localStorage.getItem('addon')
        if (!cliente) return null

        cliente = JSON.parse(cliente)

        return cliente.cliente.id
    },
    downloadAnyBase64File(base64String, defaultFileName = 'arquivo_baixado') {
        // 1. Extrair o prefixo e os dados puros da string Base64
        const parts = base64String.split(';base64,');

        // Validar se o formato é o esperado
        if (parts.length !== 2) {
            console.error("String Base64 em formato inválido. Deve incluir o prefixo `data:`. Ex: 'data:application/pdf;base64,...'");
            return;
        }

        const mimeType = parts[0].split(':')[1];
        const data = parts[1];

        // 2. Converter os dados Base64 em bytes binários
        const byteCharacters = atob(data);
        const byteArrays = [];
        const sliceSize = 512;

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        // 3. Criar o Blob com o tipo de arquivo extraído
        const blob = new Blob(byteArrays, { type: mimeType });
        const url = URL.createObjectURL(blob);

        // 4. Criar um link e configurar o download
        const link = document.createElement('a');
        link.href = url;

        // Criar um nome de arquivo, tentando adivinhar a extensão
        const fileExtension = mimeType.split('/')[1] || '';
        const fileName = `${defaultFileName}.${fileExtension}`;
        link.download = fileName;

        // 5. Simular o clique e limpar
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }

    // Exemplo de uso para um PDF
    // const pdfBase64 = "data:application/pdf;base64,JVBERi0xLjQKJ..."; 
    // downloadAnyBase64File(pdfBase64, 'relatorio_final');

    // // Exemplo de uso para um JPEG
    // const jpgBase64 = "data:image/jpeg;base64,/9j/4AAQSkZJ..."; 
    // downloadAnyBase64File(jpgBase64, 'foto_de_perfil');

    // // Exemplo de uso para um arquivo de texto
    // const txtBase64 = "data:text/plain;base64,T2xhIG11bmRvISBFc3RlIMOpIHVtIGFycXVpdm8gZGUgdGV4dG8u";
    // downloadAnyBase64File(txtBase64, 'notas');
}
